import { EditChildModalComponent } from './edit-child-modal/edit-child-modal.component';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SearchStudent } from '../../model/searchStudent';
import { StudentHelperService } from '../../service/student-helper.service';

@Component({
    selector: 'edit-child-modal-btn',
    templateUrl: './edit-child-modal-btn.component.html',
    styleUrls: ['./edit-child-modal-btn.component.scss']
})
export class EditChildModalBtnComponent implements OnInit {
    @Input() studentId!: number;
    @Input() searchStudent : SearchStudent;
    @Input() type!: 'icon' | 'string';
    @Input() displayText: string = '0000000000';
    @Input() icon: string = 'edit';

    constructor(private dialog: MatDialog,public studentHelperService:StudentHelperService) {

    }

    ngOnInit(): void {}

    // Dialog Modal
    openDialog() {        
        this.studentHelperService.setSearchStudent(this.searchStudent);
        let payload: any = {};
        payload.studentId = this.studentId;

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.data = payload;
        dialogConfig.maxHeight = '99vh';
        dialogConfig.minWidth = '90vw';
        const dialogRef = this.dialog.open(EditChildModalComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((res: any) => {
          if (res) {

                console.log(res.msg);
            }
        });
    }
}
